import { createIcon } from '@chakra-ui/react';

export const LogoutIcon = createIcon({
  displayName: 'LogoutIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M11.6265 10.2467L13.3331 8.54004L11.6265 6.83337"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.50684 8.54004H13.2868"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.84017 13.8333C4.8935 13.8333 2.50684 11.8333 2.50684 8.49996C2.50684 5.16663 4.8935 3.16663 7.84017 3.16663"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
